<template>
  <div>
    <b-table :items="submissions.data" stacked="md" responsive="md" :fields="['user', 'task', 'submitted']">
      <template v-slot:cell(user)="data">
        <router-link :to="'/users/' + data.item.user.id">{{ data.item.user.name_full }}</router-link>
      </template>
      <template  v-slot:cell(task)="data">
        <router-link :to="'/submissions/' + data.item.id">{{ data.item.form_name }}</router-link>
      </template>
      <template  v-slot:cell(submitted)="data">
        {{ data.item.created_at | moment('calendar') }}
      </template>
    </b-table>
    <b-button flat block squared to="/submissions?page=1&limit=10&sortBy=updated_at&sort=desc&filter[grade_status]=2">View All</b-button>
  </div>
</template>

<script>
export default {
  name: 'UngradedSubmissions',
  data () {
    return {
      submissions: {
        data: [],
        limit: 8
      },
      loaded: false
    };
  },
  methods: {
    loadSubmissions () {
      this.loaded = false;
      this.axios.get('submissions', {params: {'filter[grade_status]': 2}}).then(rsp => {
        this.submissions.data = rsp.data.data.map(sub => {
          switch (sub.grade_status) {
            case 0:
              sub.grade_status_text = 'Not Satisfactory';
              break;
            case 1:
              sub.grade_status_text = 'Satisfactory';
              break;
            case 2:
              sub.grade_status_text = 'Pending..';
              break;
            default:
              sub.grade_status_text = '';
              break;
          }

          return sub;
        });
        this.loaded = true;
      }).catch(err => this.$errorOut(err));
    }
  },
  mounted () {
    this.loadSubmissions();
  }
};
</script>
